const VARIABLES = {
  LESSONS: {
    TYPE: {
      LESSON: 0, // Lehet audio - video (attól függ a hasVideo true vagy false)
      EXPRESSIONLEARNER: 1, // Szókincs lecke
      CHATBOT: 2, // Régi chatbot
      DAILY: 3, // Bónusz lecke
      OVERALL: 4, // Már nincs használatban
      GRAMMAROVERALL: 5, // ?? nincs használva
      GRAMMAR: 6, // Nyelvtan lecke
      VOCABULARYPRACTICE: 9, // Generált szókincs lecke
      GRAMMARRACTICE: 10, // Generált nyelvtan lecke
      PRONUNCIATION: 11, // Kiejtés lecke
      CHATBOT_GPT: 12, // Beszédszimuláció lecke
      AI_READING: 13, // AI generált olvasás lecke
      AI_SPEAKING: 14, // AI generált beszélgetés lecke
      AI_LISTENING: 15, // AI generált hallás utáni szövegértés lecke
      DOTS: 99, // Nincs ilyen lecke arra kell, hogy a 3 pont jelenjen meg
      BUNDLE: 100 // Bundle assignment, több lecke egy assignmentben
    },
    REVERSE_TYPE: {
      0: 'LESSON',
      1: 'EXPRESSIONLEARNER',
      2: 'CHATBOT',
      3: 'DAILY',
      4: 'OVERALL',
      5: 'GRAMMAROVERALL',
      6: 'GRAMMAR',
      9: 'VOCABULARYPRACTICE',
      10: 'GRAMMARRACTICE',
      11: 'PRONUNCIATION',
      12: 'CHATBOT_GPT',
      13: 'AI_READING',
      14: 'AI_SPEAKING',
      15: 'AI_LISTENING',
      99: 'DOTS',
      100: 'BUNDLE'
    },
    EXPRESSIONS_LENGTH_IN_MIN: 0.5
  },
  ASSIGNMENT: {
    STATUS: {
      CLOSED: 0,
      OPENED: 1
    }
  }
};

export default VARIABLES;



// WEBPACK FOOTER //
// ./src/components/shared/variables.js